import { useIsClientReady } from '@belong/common';
import { Image, Link, Text } from '@belong/ui';
import { DEFAULT_REGION_PHONE_NUMBER } from 'src/features/auth/constants';
import { AUTH_STRINGS } from 'src/features/auth/strings';
import { useStore } from 'src/store';
import { regionSelector } from 'src/store/region';

export function RegionPhoneNumber() {
  const isClientReady = useIsClientReady();
  const region = useStore(regionSelector);

  const regionPhoneNumber =
    region.information?.contactInformation?.phone ??
    DEFAULT_REGION_PHONE_NUMBER;
  const regionPhoneNumberLink = `tel:+1${regionPhoneNumber.split(' ').join('')}`;

  if (!isClientReady) {
    return null;
  }

  return (
    <Link href={regionPhoneNumberLink} variant="text">
      <div className="flex items-center">
        <div className="mr-2xs h-lg w-sm">
          <Image src="/homeowner-lp/icon_phone_color.svg" alt="" />
        </div>
        <div className="pt-2xs">
          <Text as="span" className="capitalize" fontWeight="semibold">
            {AUTH_STRINGS['questions']} {regionPhoneNumber}
          </Text>
        </div>
      </div>
    </Link>
  );
}
